import React from 'react';
import { Modal, Space, message } from 'antd';
import client from '@/lib/feathers';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import type { UploadedFileInfo, announcementFormData } from '../types';
import type { RootState } from '@/redux/store';

interface PreviewAnnouncementProps {
  open: boolean;
  announcementValues: announcementFormData;
  closeAllModal: () => void;
  closePreviewAnnouncementModal: () => void;
  uploadedFileInfo: UploadedFileInfo;
}

const PreviewAnnouncement = ({
  open,
  announcementValues,
  closePreviewAnnouncementModal,
  closeAllModal,
  uploadedFileInfo,
}: PreviewAnnouncementProps) => {
  const announcementService = client.service('announcement');

  const { file, fileResponse } = uploadedFileInfo;

  const user = useSelector((state: RootState) => state.user);

  const { announcementTime, title, content } = announcementValues;

  const publishAnnouncement = async () => {
    await announcementService.create({
      ...announcementValues,
      announcementTime: dayjs(announcementTime).unix(),
      type: '一般公告',
      fileType: 'file',
      files:
        file.name === '' ? [] : [{ ...file, response: { ...fileResponse } }],
      allows: [],
      broadcastStatus: false,
      broadcastGroupId: null,
      calendarStatus: false,
      calendarId: null,
      MessageStatus: false,
      checkedStatus: false,
      announcer: user.auth.user.name,
      endTime: dayjs().endOf('M').valueOf(),
    });
    closeAllModal();
    message.success('成功發佈公告!');
  };

  return (
    <Modal
      open={open}
      onCancel={closePreviewAnnouncementModal}
      okText="確定發佈"
      onOk={publishAnnouncement}
    >
      <Space direction="vertical">
        <Space direction="vertical">
          <h5 className={styles.title}>公告時間</h5>
          <p>{dayjs(announcementTime).format('YYYY-MM-DD HH:mm')}</p>
        </Space>
        <Space direction="vertical">
          <h5 className={styles.title}>標題</h5>
          <p>{title}</p>
        </Space>
        <Space direction="vertical">
          <h5 className={styles.title}>內容</h5>
          <p>{content}</p>
        </Space>
        <Space direction="vertical">
          <h5 className={styles.title}>檔案</h5>
          <p>{file.name}</p>
        </Space>
      </Space>
    </Modal>
  );
};

export default PreviewAnnouncement;
